import { Component } from '@angular/core';

@Component({
  selector: 'loading-dots-component',
  templateUrl: './loading-dots.component.html',
  styleUrls: ['./loading-dots.component.scss']
})
export class LoadingDotsComponent {

  constructor() { }

}
